export default {
  namespaced: true,
  state: {
    rawData: {},
    data: {},
    changedParts: {},
    changedImages: {},
    openModalRow: null,
    openImageModal: {
      open: false,
      data: {},
      side: null
    },
    newPartIndex: 1,
    saveLoading: false,
    reprocessing: false,
    reprocessProgress: { current: 0, total: 0 }
  },
  getters: {},
  mutations: {
    setModalRow (state, payload) {
      state.openModalRow = payload
    },
    setImageModal (state, { open, data, side }) {
      state.openImageModal = {
        open: open,
        data: data,
        side: side
      }
    },
    setRawData (state, payload) {
      const { subtable } = payload
      if (!state.rawData[subtable]) {
        state.rawData[subtable] = {}
      }
      state.rawData[subtable] = {
        ...state.rawData[subtable],
        ...payload.data
      }
    },
    ADD_DATA (state, subtable) {
      state.data[subtable].columns.forEach((el, i) => {
        const cell = {
          index: state.data[subtable].totalCells + i++,
          rowIndex: state.data[subtable].totalRows,
          ...el,
          status: 'DRAFT',
          data: null
        }

        if (el.category === 'static' && el.type === 'index') {
          cell.data = state.data[subtable].totalRows + 1
        }
        if (el.category === 'static' && el.type === 'id') {
          cell.data = 'new-' + state.newPartIndex
        }

        if (el.category === 'fieldsArray' || el.category === 'attr') {
          cell.data = []
        }

        if (el.category === 'field') {
          cell.data = ''
        }
        if (el.category === 'select') {
          cell.data = Array.isArray(el.possible) && el.possible.length ? el.possible[0] : 'draft'
        }
        if (el.category === 'checkbox') {
          cell.data = false
        }
        if (el.category === 'image' || el.category === 'children') {
          cell.data = {
            type: el.type,
            typeImage: el.category,
            sides: el.sides || [],
            mime: 'svg',
            part_id: 'new-' + state.newPartIndex,
            alg: el.alg,
            attrs: el.attrs || [],
            params: el.params || [],
            isNew: true
          }
          if (el.side) {
            cell.data.sides.push(el.side)
          }
          cell.category = 'image'
        }
        if (el.category === 'params') {
          cell.data = {}
        }
        if (el.category === 'defaultparams') {
          cell.category = 'params'
          cell.data = {}
        }
        if (el.category === 'params' && el.type === 'allowed_params') {
          cell.category = 'allowedparams'
        }

        if (el.type === 'allowed_params') {
          cell.data = {}
          el.values.forEach(item => {
            if (!cell.data[item.name]) {
              cell.data[item.name] = {
                display_name: item.display_name,
                possible: Object.assign({}, item.possible),
                selected: []
              }
            }
          })
        }

        if (cell.category !== 'attr' && cell.category !== 'static' && cell.category !== 'image' && cell.category !== 'children') {
          state.changedParts[subtable]['new-' + state.newPartIndex].allData[el.type] = cell
        }
        if (cell.category === 'attr') {
          if (!state.changedParts[subtable]['new-' + state.newPartIndex].allData.attr) {
            state.changedParts[subtable]['new-' + state.newPartIndex].allData.attr = {}
          }
          state.changedParts[subtable]['new-' + state.newPartIndex].allData.attr[el.type] = cell
        }
        state.data[subtable].parts.push(cell)
      })

      state.newPartIndex++

      // Calculate table
      state.data[subtable].totalRows = state.data[subtable].totalRows + 1
      state.data[subtable].totalCells = state.data[subtable].totalCols * state.data[subtable].totalRows
    },
    DEL_ROW_DATA (state, { rowIndex, subtable }) {
      state.data[subtable].parts = state.data[subtable].parts.filter(el => el.rowIndex !== rowIndex)
      state.data[subtable].totalRows = state.data[subtable].totalRows - 1
      state.data[subtable].totalCells = state.data[subtable].totalCols * state.data[subtable].totalRows
    },

    setData (state, payload) {
      const { subtable } = payload
      if (!state.data[subtable]) {
        state.data[subtable] = {}
      }

      // add custom columns
      if (state.rawData[subtable].columns[0].name !== '#') {
        state.rawData[subtable].columns?.unshift(
          {
            category: 'static',
            name: '#',
            source: { name: 'index' }
          },
          {
            category: 'static',
            name: 'id',
            source: { name: 'id' }
          }
        )
      }

      // Calculate table
      state.data[subtable].totalCols = state.rawData[subtable].columns.length
      state.data[subtable].totalRows = state.rawData[subtable].parts.length
      state.data[subtable].totalCells = state.data[subtable].totalCols * state.data[subtable].totalRows

      // columns
      state.data[subtable].columns = []
      state.rawData[subtable].columns.forEach((c, i) => {
        const column = {
          colIndex: i,
          name: c.name,
          category: c.category,
          type: c.source.name || c.source.type,
          optional: c.optional || false,
          filtering: c.filtering || false
          // isArray: !!c.source.dataType
        }
        if (c.source.name === 'allowed_params') column.values = c.source.values
        if (c.source.possible) column.possible = c.source.possible
        if (c.source.dataType === 'array') column.category += 'sArray'
        if (column.category === 'image') column.side = c.source.side
        if (column.category === 'children') {
          if (c.source.sides) column.sides = c.source.sides
          if (c.source.side) column.side = c.source.side
        }
        if (column.category === 'image' || column.category === 'children') {
          column.alg = c.source.alg
          column.showAlg = c.source.show_alg || false
          column.all_params = c.source.params || []
          column.reqiured_params = []
          if (c.source.params?.length) {
            c.source.params.forEach(el => {
              if (!c.source.optional_params?.includes(el)) column.reqiured_params.push(el)
            })
          }
          if (c.source.attributes?.length > 0 || c.source.optional_attributes?.length > 0) {
            column.reqiured_attrs = []
            column.all_attrs = c.source.attributes || []
            if (c.source.attributes?.length) {
              c.source.attributes.forEach(el => {
                if (!c.source.optional_attributes?.includes(el)) {
                  column.reqiured_attrs.push(el)
                }
              })
            }
          }
        }
        if (column.category === 'attr') {
          column.singular = c.singular || false
        }

        // Sanitize data
        column.category = column.category.replaceAll('_', '')

        state.data[subtable].columns.push(column)
      })

      // parts
      state.data[subtable].parts = Array.from(
        { length: state.data[subtable].totalCells },
        (v, i) => {
          const part = state.rawData[subtable].parts[Math.floor(i / state.data[subtable].totalCols)]
          const column = state.data[subtable].columns[i % state.data[subtable].totalCols]
          const cell = {
            index: i,
            rowIndex: Math.floor(i / state.data[subtable].totalCols),
            ...column,
            data: null
          }

          cell.status = part.status

          cell.data = part[column.type] !== undefined
            ? part[column.type]
            : part.attrs.filter(attr => attr.type === column.type)

          if (column.category === 'image' || column.category === 'children') {
            cell.data = {
              typeImage: column.category,
              part_id: part.id,
              type: column.type,
              sides: column.sides || []
            }
            if (column.side) {
              cell.data.sides.push(column.side)
            }
            cell.category = 'image'

            const imgCount = state.rawData[subtable].imgCount.find(el => {
              return (
                el.part_id === part.id &&
                el.side === (column.side || column.sides[0]) &&
                el.type === column.type
              )
            })
            cell.data.imgCount = imgCount?.count || 0
          }
          if (column.category === 'defaultparams') {
            cell.category = 'params'
          }
          if (column.category === 'params' && column.type === 'allowed_params') {
            cell.category = 'allowedparams'
          }

          if (column.type === 'allowed_params') {
            if (Array.isArray(cell.data)) cell.data = {}
            column.values.forEach(el => {
              if (!cell.data[el.name]) {
                cell.data[el.name] = {
                  display_name: el.display_name,
                  possible: Object.assign({}, el.possible),
                  selected: []
                }
              }
            })
          }

          if (
            (column.category === 'params' || column.category === 'paramssArray') &&
            Array.isArray(cell.data)
          ) {
            cell.data = {}
          }

          // Add custom data
          if (column.type === 'index') cell.data = cell.rowIndex + 1

          return cell
        }
      )
    },
    SET_CHANGED_PARTS_NEW (state, { subtable, id }) {
      if (!state.changedParts[subtable]) state.changedParts[subtable] = {}
      state.changedParts[subtable]['new-' + id] = {
        data: {},
        allData: {},
        allAttr: []
      }
    },
    SET_CHANGED_PARTS (state, { subtable, data, tag }) {
      const id = state.data[subtable].parts.find(el => el.rowIndex === data.rowIndex && el.name === 'id')?.data
      if (!state.changedParts[subtable]) {
        state.changedParts[subtable] = {}
      }
      if (!state.changedParts[subtable][id]) {
        state.changedParts[subtable][id] = {
          data: {},
          allData: {},
          allAttr: []
        }
      }
      if (data.category === 'attr') {
        if (!state.changedParts[subtable][id].allData[data.category]) {
          state.changedParts[subtable][id].allData[data.category] = {}
        }
        state.changedParts[subtable][id].allData[data.category][data.type] = data
      } else if (data.type !== 'delete_image_ids') state.changedParts[subtable][id].allData[data.type] = data
      if (data.type === 'delete_image_ids') {
        if (!state.changedParts[subtable][id].data[data.type]) {
          state.changedParts[subtable][id].data[data.type] = []
          state.changedParts[subtable][id].allData[data.type] = []
        }
        state.changedParts[subtable][id].data[data.type].push(data.id)
        state.changedParts[subtable][id].allData[data.type].push(data.value)
      } else if (data.type === 'newimage') {
        if (!state.changedParts[subtable][id].data.image_ids) {
          state.changedParts[subtable][id].data.image_ids = []
        }
        state.changedParts[subtable][id].data.image_ids.push(data.value)
        if (!state.changedParts[subtable][id].allData.image) {
          state.changedParts[subtable][id].allData.image = {}
        }
        state.changedParts[subtable][id].allData.image[data.value] = data.imageType
      } else if (data.type === 'allowed_params') {
        if (!state.changedParts[subtable][id].data[data.type]) {
          state.changedParts[subtable][id].data[data.type] = {}
        }
        for (const key in data.data) {
          state.changedParts[subtable][id].data[data.type][key] = data.data[key].selected
        }
      } else if (data.category === 'attr') {
        if (state.changedParts[subtable][id].allAttr.length === 0) {
          const clone = state.rawData[subtable].parts.find(el => el.id === id)?.attrs.slice()
          let dataArray = []
          if (clone) dataArray = clone.filter(el => el.type !== data.type)
          Array.prototype.push.apply(dataArray, data.data)
          state.changedParts[subtable][id].allAttr = dataArray
        } else {
          state.changedParts[subtable][id].allAttr = state.changedParts[subtable][id].allAttr.filter(el => el.type !== data.type)
          Array.prototype.push.apply(state.changedParts[subtable][id].allAttr, data.data)
        }
        state.changedParts[subtable][id].data.attributes = state.changedParts[subtable][id].allAttr.map(el => el.id)
      } else if (data.category === 'field') {
        state.changedParts[subtable][id].data[data.type] = data.data.replace(/  +/g, ' ').trim()
      } else {
        state.changedParts[subtable][id].data[data.type] = data.data
      }
    },
    DEL_CHANGED_PARTS (state) {
      state.changedParts = {}
    },
    DEL_CHANGED_PARTS_PART (state, { id, subtable, isNewDel }) {
      if (state.changedParts?.[subtable]?.[id]) {
        delete state.changedParts[subtable][id]
        if (isNewDel && Object.keys(state.changedParts[subtable]).length === 0) {
          delete state.changedParts[subtable]
        }
      }
    },
    SET_FILTER_PARTS_STATUS (state, { id, status, subtable }) {
      if (state.data[subtable]) {
        const rowIndex = state.data[subtable].parts.find(el => el.name === 'id' && el.data === Number(id))?.rowIndex
        if (rowIndex) {
          state.data[subtable].parts.forEach(el => {
            if (el.rowIndex === rowIndex) el.status = status
          })
        }
      }
    },
    DEL_CHANGED_IMAGES (state) {
      state.changedImages = {}
    },
    DEL_CHANGED_IMAGE (state, { id, subtable, isNewDel }) {
      if (state.changedImages[subtable]?.[id]) {
        delete state.changedImages[subtable][id]
        if (isNewDel && Object.keys(state.changedImages[subtable]).length === 0) {
          delete state.changedImages[subtable]
        }
      }
    },
    DEL_CHANGED_IMAGE_IN_PART (state, { subtable, partId }) {
      if (state.changedImages[subtable]) {
        const arrayKeys = Object.keys(state.changedImages[subtable])
        arrayKeys.forEach(el => {
          if (el.includes(partId)) delete state.changedImages[subtable][el]
        })
        if (Object.keys(state.changedImages[subtable]).length === 0) {
          delete state.changedImages[subtable]
        }
      }
    },
    SET_CHANGED_IMAGES (state, { subtable, data, field, oldParams, partInfo, isUpdate }) {
      if (!state.changedImages[subtable]) {
        state.changedImages[subtable] = {}
      }
      if (!state.changedImages[subtable][data.id]) {
        state.changedImages[subtable][data.id] = {
          side: data.side,
          type: data.type,
          part_id: partInfo.data.part_id,
          alg: data.alg,
          data: {},
          oldParams: oldParams,
          index: partInfo.index,
          colIndex: partInfo.colIndex,
          rowIndex: partInfo.rowIndex,
          reqiured_params: partInfo.reqiured_params,
          all_params: partInfo.all_params,
          reqiured_attrs: partInfo.reqiured_attrs,
          all_attrs: partInfo.all_attrs,
          name: partInfo.name,
          isUpdate: isUpdate || false
        }
      }
      if (field === 'attrs') {
        state.changedImages[subtable][data.id].attrs = data[field]
        state.changedImages[subtable][data.id].data.attributes = []
        data[field].forEach(el => {
          state.changedImages[subtable][data.id].data.attributes.push(el.id)
        })
        if (data.params) state.changedImages[subtable][data.id].data.params = data.params
      } else state.changedImages[subtable][data.id].data[field] = data[field]
    },
    SET_REPROCESSING (state, value) {
      state.reprocessing = value
    },
    SET_REPROCESS_PROGRESS (state, { current, total }) {
      state.reprocessProgress = { current, total }
    }
  },
  actions: {
    async getImageBuId ({ rootState }, id) {
      const getImageBuId = await fetch(`${rootState.api.host}${rootState.api.endpoint.loadImg}/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
      if (getImageBuId.ok) {
        return await getImageBuId.json()
      }
    },
    async copyPart ({ state, rootState, commit }, { subtable, rowIndex }) {
      if (!state.changedParts[subtable]) state.changedParts[subtable] = {}
      state.changedParts[subtable]['copy-' + state.newPartIndex] = {
        data: {},
        allData: {},
        allAttr: []
      }
      const partData = []
      let copiedPartId = null
      state.data[subtable].parts.forEach(el => {
        if (el.rowIndex === rowIndex) {
          if (el.name === 'id') copiedPartId = el.data
          const obj = Object.assign({}, el)
          if (el.category === 'allowedparams') {
            obj.data = {}
            for (const key in el.data) {
              obj.data[key] = {
                ...el.data[key]
              }
            }
          } else if (Array.isArray(el.data)) {
            const cloneData = Object.assign([], el.data)
            obj.data = cloneData
          } else if (el.data instanceof Object) {
            const cloneData = Object.assign({}, el.data)
            obj.data = cloneData
          }
          partData.push(obj)
        }
      })
      let partImages
      const getPartImage = await fetch(`${rootState.api.host}${rootState.api.endpoint.loadImg}?part_id=${copiedPartId}&noImages=1`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
      if (getPartImage.ok) {
        partImages = await getPartImage.json()
      }
      if (partImages?.part_images?.length > 0) {
        state.changedParts[subtable]['copy-' + state.newPartIndex].data.image_ids =
          partImages.part_images.map(img => img.id)
      }
      partData.forEach((el, index) => {
        el.rowIndex = state.data[subtable].totalRows
        el.index = state.data[subtable].totalCells + index++
        if (el.name === 'id') {
          el.data = 'copy-' + state.newPartIndex
        } else if (el.name === '#') {
          el.data = state.data[subtable].totalRows + 1
        } else if (el.category === 'attr') {
          if (!state.changedParts[subtable]['copy-' + state.newPartIndex].data.attributes) {
            state.changedParts[subtable]['copy-' + state.newPartIndex].data.attributes = []
          }
          if (el.data.length > 0) {
            state.changedParts[subtable]['copy-' + state.newPartIndex].allAttr = state.changedParts[subtable]['copy-' + state.newPartIndex].allAttr.concat(el.data)
            const attrIds = el.data.map(el => el.id)
            state.changedParts[subtable]['copy-' + state.newPartIndex].data.attributes = state.changedParts[subtable]['copy-' + state.newPartIndex].data.attributes.concat(attrIds)
          }
        } else if (el.type === 'allowed_params') {
          state.changedParts[subtable]['copy-' + state.newPartIndex].data[el.type] = {}
          for (const key in el.data) {
            state.changedParts[subtable]['copy-' + state.newPartIndex].data[el.type][key] = el.data[key].selected
          }
        } else if (el.category === 'image' || el.category === 'children') {
          el.data.part_id = 'copy-' + state.newPartIndex
          el.data.imgCount = partImages?.part_images?.filter(img => {
            return img.side === (el.data.side || el.data.sides[0]) && img.type === el.data.type
          }).length || 0
        } else {
          state.changedParts[subtable]['copy-' + state.newPartIndex].data[el.type] = el.data
        }
        state.data[subtable].parts.push(el)
      })
      state.data[subtable].totalRows++
      state.data[subtable].totalCells = state.data[subtable].totalCols * state.data[subtable].totalRows
      state.newPartIndex++
    },
    async delPart ({ rootState, commit }, { id, subtable }) {
      commit('SET_FILTER_PARTS_STATUS', { id: id, status: 'UPDATING', subtable: subtable })
      const delPart = await fetch(`${rootState.api.host}${rootState.api.endpoint.parts}/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
      if (delPart.ok) {
        commit('DEL_CHANGED_PARTS_PART', { subtable: subtable, id: id, isNewDel: true })
        return true
      } else {
        commit('SET_FILTER_PARTS_STATUS', { id: id, status: 'ACTIVE', subtable: subtable })
      }
    },
    addData ({ state, commit }, subtable) {
      // addChangedParts
      commit('SET_CHANGED_PARTS_NEW', ({ subtable: subtable, id: state.newPartIndex }))
      commit('ADD_DATA', subtable)
    },
    async afterUpdatedParts ({ rootState, commit }, { id, subtable }) {
      commit('notifications/addNotification', {
        notification: {
          type: 'success',
          message: `Part with # ${id} updated`
        }
      }, { root: true })
      commit('SET_FILTER_PARTS_STATUS', { id: id, status: 'ACTIVE', subtable: subtable })
    },
    async saveChangedPartsData ({ rootState, state, commit, dispatch }, subtable) {
      if (state.changedParts[subtable]) {
        if (Object.keys(state.changedParts[subtable]).length > 0) {
          if (!localStorage.getItem('disable-validation')) {
            await dispatch('partsErrors/validateParts', subtable, { root: true })
          }
          if (
            Object.keys(rootState.partsErrors.errors).length > 0 &&
            Object.keys(rootState.partsErrors.errors[subtable]).length > 0
          ) {
            rootState.partsErrors.showErros = true
            state.saveLoading = false
            return false
          } else rootState.partsErrors.showErros = false

          for (const key in state.changedParts[subtable]) {
            commit('SET_FILTER_PARTS_STATUS', { id: key, status: 'UPDATING', subtable: subtable })
            // если новая стока
            if (key.includes('new') || key.includes('copy')) {
              const categoryId = Number(subtable.split('-')[0])
              const putPartNew = await fetch(`${rootState.api.host}${rootState.api.endpoint.parts}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json;charset=utf-8',
                  Authorization: 'Bearer ' + rootState.user.accesToken
                },
                body: JSON.stringify({
                  ...state.changedParts[subtable][key].data,
                  category_id: categoryId
                })
              })
              if (putPartNew.ok) {
                const createdRowIndex = state.data[subtable].parts.find(
                  part => part.type === 'id' && part.data === key
                )?.rowIndex
                commit('DEL_CHANGED_PARTS_PART', { subtable: subtable, id: key })
                const responce = await putPartNew.json()
                if (responce.part.id) {
                  state.data[subtable].parts.forEach(part => {
                    if (part.type === 'id' && part.data === key) {
                      part.data = responce.part.id
                    } else if (part.category === 'image' && part.rowIndex === createdRowIndex) {
                      part.data.part_id = responce.part.id
                    }
                  })
                }
              } else {
                commit('SET_FILTER_PARTS_STATUS', { id: key, status: 'ACTIVE', subtable: subtable })
              }
            } else {
              // не блокировать строку, если обновляется только картинка обтачек
              if (state.changedParts[subtable][key].data.image_ids) {
                const ruffle = state.changedParts[subtable][key].data.image_ids.filter(img => {
                  return state.changedParts[subtable][key].allData.image[img] === 'ruffle'
                })
                if (
                  ruffle.length === state.changedParts[subtable][key].data.image_ids.length &&
                  Object.keys(state.changedParts[subtable][key].data).length === 1
                ) {
                  commit('SET_FILTER_PARTS_STATUS', { id: key, status: 'ACTIVE', subtable: subtable })
                }
              }
              // если редактируется строка
              const putPart = await fetch(`${rootState.api.host}${rootState.api.endpoint.parts}/${key}`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json;charset=utf-8',
                  Authorization: 'Bearer ' + rootState.user.accesToken
                },
                body: JSON.stringify(state.changedParts[subtable][key].data)
              })
              if (putPart.ok) {
                commit('DEL_CHANGED_PARTS_PART', { subtable: subtable, id: key })
              } else {
                commit('SET_FILTER_PARTS_STATUS', { id: key, status: 'ACTIVE', subtable: subtable })
              }
            }
          }
          if (Object.keys(state.changedParts[subtable]).length === 0) {
            commit('notifications/addNotification', {
              notification: {
                type: 'success',
                message: 'All rows sent'
              }
            }, { root: true })
            commit('DEL_CHANGED_PARTS')
            return true
          } else {
            commit('notifications/addNotification', {
              notification: {
                type: 'danger',
                message: 'Not all rows sent. Try save again.'
              }
            }, { root: true })
            state.saveLoading = false
            return false
          }
        }
      }
      return true
    },
    async saveChangedPartsImg ({ rootState, state, commit, dispatch }, subtable) {
      if (state.changedImages[subtable]) {
        if (Object.keys(state.changedImages[subtable]).length > 0) {
          if (!localStorage.getItem('disable-validation')) {
            await dispatch('partsErrors/validateParts', subtable, { root: true })
          }
          if (
            Object.keys(rootState.partsErrors.errors).length > 0 &&
            Object.keys(rootState.partsErrors.errors[subtable]).length > 0
          ) {
            rootState.partsErrors.showErros = true
            state.saveLoading = false
            return false
          } else rootState.partsErrors.showErros = false
          for (const key in state.changedImages[subtable]) {
            const value = state.changedImages[subtable][key]
            if (state.changedImages[subtable][key].type === 'ruffle') {
              commit('SET_FILTER_PARTS_STATUS', { id: value.part_id, status: 'UPDATING', subtable: subtable })
            }
            if (!key.includes('new')) {
              const putImage = await fetch(`${rootState.api.host}${rootState.api.endpoint.loadImg}/${key}`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json;charset=utf-8',
                  Authorization: 'Bearer ' + rootState.user.accesToken
                },
                body: JSON.stringify(value.data)
              })
              if (putImage.ok) {
                commit('SET_CHANGED_PARTS', {
                  subtable: subtable,
                  data: {
                    value: key,
                    rowIndex: value.rowIndex,
                    type: 'newimage',
                    imageType: state.changedImages[subtable][key].type
                  }
                })
                commit('DEL_CHANGED_IMAGE', { subtable: subtable, id: key })
              } else {
                commit('SET_FILTER_PARTS_STATUS', { id: value.part_id, status: 'ACTIVE', subtable: subtable })
              }
            } else {
              const sendImg = await fetch(`${rootState.api.host}${rootState.api.endpoint.sendImg}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json;charset=utf-8',
                  Authorization: 'Bearer ' + rootState.user.accesToken
                },
                body: JSON.stringify({
                  ...value.data,
                  side: value.side,
                  type: value.type
                })
              })
              if (sendImg.ok) {
                const responce = await sendImg.json()
                commit('SET_CHANGED_PARTS', {
                  subtable: subtable,
                  data: {
                    value: responce.id,
                    rowIndex: value.rowIndex,
                    type: 'newimage'
                  }
                })
                commit('DEL_CHANGED_IMAGE', { subtable: subtable, id: key })
                state.data[subtable].parts.forEach(part => {
                  if (part.rowIndex === value.rowIndex && part.colIndex === value.colIndex) {
                    part.data.imgCount++
                  }
                })
              } else {
                commit('SET_FILTER_PARTS_STATUS', { id: value.part_id, status: 'ACTIVE', subtable: subtable })
              }
            }
          }
          if (Object.keys(state.changedImages[subtable]).length === 0) {
            commit('notifications/addNotification', {
              notification: {
                type: 'success',
                message: 'All images sent'
              }
            }, { root: true })
            commit('DEL_CHANGED_IMAGES')
            return true
          } else {
            commit('notifications/addNotification', {
              notification: {
                type: 'danger',
                message: 'Not all images sent. Try save again.'
              }
            }, { root: true })
            state.saveLoading = false
            return false
          }
        }
      }
      return true
    },
    async saveChangedParts ({ state, dispatch }, subtable) {
      state.saveLoading = true
      const saveImg = await dispatch('saveChangedPartsImg', subtable)
      const saveData = await dispatch('saveChangedPartsData', subtable)
      await dispatch('refreshRawParts', subtable)
      state.saveLoading = false
      if (saveData && saveImg) {
        return true
      } else return false
    },
    async refreshRawParts ({ rootState, commit }, subtable) {
      const categoryId = subtable.split('-')[0]
      const response = await fetch(
        `${rootState.api.host}${rootState.api.endpoint.parts}?category_id=${categoryId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            Authorization: 'Bearer ' + rootState.user.accesToken
          }
        }
      )
      if (response.ok) {
        commit('setRawData', { subtable, data: await response.json() })
      }
    },
    async reprocessAllParts ({ rootState, state, commit }, subtable) {
      const tableData = state.data[subtable]
      if (!tableData) return false

      const partIds = []
      for (let i = 0; i < tableData.parts.length; i++) {
        const cell = tableData.parts[i]
        if (cell.type === 'id' && cell.data && !String(cell.data).includes('new')) {
          partIds.push(cell.data)
        }
      }

      if (!partIds.length) return false

      commit('SET_REPROCESSING', true)
      commit('SET_REPROCESS_PROGRESS', { current: 0, total: partIds.length })

      const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))
      let errorCount = 0
      for (const id of partIds) {
        if (!state.reprocessing) break

        const rowIndex = tableData.parts.find(
          p => p.type === 'id' && p.data === id
        )?.rowIndex

        if (rowIndex !== undefined) {
          commit('ui/setCellStatus', {
            db: subtable,
            key: 'rowsStates',
            index: rowIndex,
            status: { updating: true }
          }, { root: true })
        }

        try {
          const resp = await fetch(
            `${rootState.api.host}${rootState.api.endpoint.parts}/${id}/reprocess`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json;charset=utf-8',
                Authorization: 'Bearer ' + rootState.user.accesToken
              }
            }
          )
          if (!resp.ok) {
            errorCount++
          }
        } catch (e) {
          errorCount++
        }

        if (rowIndex !== undefined) {
          commit('ui/setCellStatus', {
            db: subtable,
            key: 'rowsStates',
            index: rowIndex,
            status: { updating: false }
          }, { root: true })
        }

        commit('SET_REPROCESS_PROGRESS', {
          current: state.reprocessProgress.current + 1,
          total: partIds.length
        })

        await delay(2000)
      }

      const wasAborted = !state.reprocessing
      commit('SET_REPROCESSING', false)

      commit('notifications/addNotification', {
        notification: {
          type: errorCount > 0 ? 'warning' : 'success',
          message: wasAborted
            ? `Reprocessing cancelled (${state.reprocessProgress.current}/${partIds.length} processed)`
            : errorCount > 0
              ? `Reprocessed with ${errorCount} error(s) out of ${partIds.length} parts`
              : `All ${partIds.length} parts sent for reprocessing`
        }
      }, { root: true })

      return errorCount === 0
    },
    cancelReprocess ({ commit }) {
      commit('SET_REPROCESSING', false)
    },
    async getPart ({ rootState }, id) {
      return await fetch(`${rootState.api.host}${rootState.api.endpoint.parts}/${id}`, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      }).then(r => r.json()).then(data => data.part)
    },
    getParts ({ rootState, state, commit }, payload) {
      const { subtable } = payload
      const id = subtable.split('-')[0]
      const code = subtable.split('-')[1]
      const apiData = {
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      }
      const host = rootState.api.host
      const endpoints = rootState.api.endpoint

      const promises = [
        fetch(`${host}${endpoints.part_categories_schema}?code=${code}&context=${payload.table}`, apiData)
          .then(response => response.json())
          .then(data => commit('setRawData', { subtable, data })),
        fetch(`${host}${endpoints.parts}?category_id=${id}`, apiData)
          .then(response => response.json())
          .then(data => commit('setRawData', { subtable, data })),
        fetch(`${host}${endpoints.getImgCount}?category_id=${id}`, apiData)
          .then(response => response.json())
          .then(data => commit('setRawData', { subtable, data: { imgCount: data } }))
      ]
      return Promise.all(promises).then(() => commit('setData', { subtable })).then(() => {
        // Set column status
        for (let i = 0; i < state.data[subtable].totalCols; i++) {
          if (['algs', 'name'].includes(state.data[subtable].columns[i].type)) {
            commit('ui/setCellStatus', {
              db: subtable,
              key: 'colsStates',
              index: state.data[subtable].parts[i].colIndex,
              status: { sticky: true }
            }, { root: true })
            break
          }
        }
        // Set rows status
        for (let i = 0; i < state.data[subtable].totalCells; i += state.data[subtable].totalCols) {
          commit('ui/setCellStatus', {
            db: subtable,
            key: 'rowsStates',
            index: state.data[subtable].parts[i].rowIndex,
            status: {
              updating: state.data[subtable].parts[i].status !== 'ACTIVE'
            }
          }, { root: true })
        }
      })
    }
  }
}
